export interface CreateOrderQueryAction {
  hasCreateParam: boolean;
  openWizard: boolean;
}

export function getCreateOrderQueryAction(
  createParam: string | null,
  canManageOrders: boolean
): CreateOrderQueryAction {
  const hasCreateParam = createParam === 'true';
  return {
    hasCreateParam,
    openWizard: hasCreateParam && canManageOrders,
  };
}
